<script>
    import { browser } from '$app/environment';
    import { pushState } from '$app/navigation';

    export let drawerOpen;
    export let position;
    export let name;

    // history state for draw open/closed history.back();
    $: if (drawerOpen) {
        if (browser) {
            pushState('', {
                [name]: true
            });
            addEventListener('popstate', () => {}); // TODO: Move to layout hydration probably dont need to have multi listeners
            onpopstate = () => {
                if (drawerOpen) {
                    drawerOpen = false;
                }
            };
        }
    }

    // recieves status to open cart draw from cartLayout.svelte
    // passes state up to Drawer.svelte
    let setDrawerCallback = (state) => {
        drawerOpen = state ? state : false;
    };
</script>

<button
    aria-label="Close Menu"
    class="drawScreen fixed left-0 top-0 z-40 h-screen w-screen bg-black/40"
    class:open={drawerOpen}
    on:click={() => history.back()}
/>

<div class="draw-{position} no-scrollbar fixed bottom-0 top-0 z-50 bg-color-background dark:bg-base-900" class:open={drawerOpen} id={name}>
    <slot {setDrawerCallback} />
</div>

<svelte:head>
    {#if drawerOpen}
        <style>
            body {
                overflow: hidden !important;
            }
        </style>
    {/if}
</svelte:head>

<style>
    .draw-left {
        width: 400px;
        max-width: 85%;
        top: 0px;
        left: -400px;
        transition: left 0.4s cubic-bezier(0.46, 0.01, 0.32, 1);
    }
    .draw-right {
        width: 400px;
        max-width: 91%;
        top: 0px;
        right: -400px;
        transition: right 0.4s cubic-bezier(0.46, 0.01, 0.32, 1);
    }
    .draw-bottom {
        width: 100%;
        bottom: -100%;
        transition: bottom 0.4s cubic-bezier(0.82, 0.085, 0.395, 0.895);
    }

    .draw-left.open {
        left: 0px;
    }
    .draw-right.open {
        right: 0px;
    }
    .draw-bottom.open {
        bottom: 0px;
    }

    .drawScreen {
        display: none;
    }
    .drawScreen.open {
        display: block;
    }
</style>
